module.exports = __webpack_public_path__ + "img/factory_panel_PVC.4d6bc290.jpg";